import { helloCore } from '@petsure/core';

export class HelloComponentController {
    name: string = 'Angular JS';
    message: string = '';

    $onInit() {
        this.message = helloCore(this.name);
    }
}

export const HelloComponent = {
    bindings: {
        name: '@'
    },
    controller: HelloComponentController,
    template: `<h1>{{ $ctrl.message }}</h1>`
};